// @flow
const image = {
  width: '40px',
  paddingLeft: '10px',
};

const text = {
  paddingLeft: '10px',
};

export default { image, text };




// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/UserSelect/components/UserRow/style.js